$('#ProductWizard').steps({
     
    onChange: function(CurrentIndex, NextIndex, Direction){
        
        /**
         * Only validate when going forward
         */
        if(Direction === 'forward'){
                                                  
            /**
             * Validate current block
             */
            //if (!$('#ProductWizardForm').parsley().validate(`block-${CurrentIndex}`)){
            //    $("#ValidationError").removeClass('d-none');
            //    return false;
            //}            

            /**
             * Check validation error visiblity
             */
            if(!$("#ValidationError").hasClass("d-none")){
                $("#ValidationError").addClass('d-none');
            }

            return true;
        }

        return true;
    },

    onFinish: function () {

        var Form = $('#ProductWizardForm');

        if(!$(Form).parsley().isValid()){
            $("#ValidationError").removeClass('d-none');
            return false;
        }

        $.ajax({
            method: 'POST',
            url: Form.attr('action'),
            data: $(Form).serialize(),
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },

            success: function (data) {

                if(data){
                    window.location.replace(data);
                }
            }
        });
    }
});

$('#EnableOrderInvoiceAddress').on('click', function () {

    if ($("#OrderInvoiceAddress").hasClass('d-none')) {
    
        /**
         * 
         */
        $("#OrderInvoiceAddress").removeClass('d-none');

        $("#ProductWizardForm input[name='Addresses[Invoice][Address]']").attr('required');
        $("#ProductWizardForm input[name='Addresses[Invoice][ZIP]']").attr('required');
        $("#ProductWizardForm input[name='Addresses[Invoice][City]']").attr('required');


    } else {

        /**
         * Hide Invoice Address fields
         */
        $("#OrderInvoiceAddress").addClass('d-none');

        /**
         * Disable requirment of fields
         */
        $("#ProductWizardForm input[name='Addresses[Invoice][Address]']").removeAttr('required');
        $("#ProductWizardForm input[name='Addresses[Invoice][ZIP]']").removeAttr('required');
        $("#ProductWizardForm input[name='Addresses[Invoice][City]']").removeAttr('required');
    }

});

/**
 * Calculate OrderTotal
 */
$("#ProductWizardForm input[name='Quantity']").on("input", function () {
    
    let Price = $("#ProductWizardForm input[name='Price']").val();
    let Quantity = $("#ProductWizardForm input[name='Quantity']").val();
        
    var Formatter = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',            
    });
        
    $("#OrderTotal").html(Formatter.format(Price * Quantity));
});